module.exports = __webpack_public_path__ + "img/firststone.73ca0471.jpg";